
export async function generateOneTimePassword(uid) {
    try {
      const response = await fetch('/Logon/SetInitPwd', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ uid }),
      });
  
      const data = await response.json();
      if (data.err === 0) {
        alert('The authentication key has been sent to the company email you provided. \nPlease check your email and enter the [CMS Email Authentication Key].');
      } else {
        alert(data.resultMsg);
      }
    } catch (error) {
      alert('Error: ' + error.message);
    }
  }
  
  export async function resetPassword(uid,uemail) {
    try {
      const response = await fetch('/Logon/ResetInitPwd', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ uid,uemail }),
      });
  
      const data = await response.json();
      if (data.err === 0) {
        alert(' The password has been reset to the default. \n Please log in again using the password provided in the email and set a new password.');
        window.location.href = window.location.origin;
      } else {
        alert(data.resultMsg);
      }
    } catch (error) {
      alert('Error: ' + error.message);
    }
  }
  